<template>
  <b-modal id="detail-modal" ok-only centered ok-title="Ok" title="Detail" size="xl" @show="detail">
    <MyLoading :loading-show="loadingShow" />
    <b-form>
      <b-form-group>
        <b-table thead-class="d-none" striped hover :items="data" />

        <div v-if="expirationFolder" class="d-flex align-items-center flex-wrap mb-2">
          <strong class="mr-1">Scadenza:</strong>
          <ExpirationBadge v-if="hasExpirationDate" :expiration-date="expirationFolder.expiration_date" />
          <span v-else class="text-muted">—</span>
          <b-button v-if="canEditExpiration" variant="link" size="sm" class="p-0 ml-1" @click="editExpiration">
            Modifica scadenza
          </b-button>
        </div>

        <div v-if="version.length > 0">
          <h3>Versione</h3>
          <hr>
          <b-table striped hover :fields="fields" :items="version">
            <template #cell(download)="data">
              <b-button @click="download(data.item.uuid, data.item.label)" variant="primary">
                Scarica
              </b-button>
            </template>
            <template #cell(version_render)="data">
              {{ data.item.version }}.{{ data.item.minor_version }}
            </template>
          </b-table>
        </div>

        <div v-if="activity.length > 0">
          <h3>Attività</h3>
          <hr>
          <b-table striped hover :fields="activityFields" :items="activity" />
        </div>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BModal, BForm, BFormGroup, BTable, BButton
} from 'bootstrap-vue'
import * as dateHelpers from '@/helpers/date-helpers'
import useMyStore from '@/services/useMyStore'
import MyLoading from '@/layouts/components/MyLoading.vue'
import ExpirationBadge from '@/layouts/components/ExpirationBadge.vue'
import * as expirationHelpers from '@/helpers/expiration-helpers'
import moment from 'moment'
import objectsRepository from '@/api/objectsRepository'

export default {
  name: 'Modal',
  components: {
    BModal,
    BForm,
    BButton,
    BFormGroup,
    BTable,
    MyLoading,
    ExpirationBadge,
  },
  props: {
    files: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  setup() {
    const { currentObject } = useMyStore()
    return { currentObject }
  },
  data() {
    return {
      id: this.currentObject,
      label: '',
      data: [],
      version: [],
      fields: [{ key: 'label', label: 'Nome' }, { key: 'version_render', label: 'Versione' }, { key: 'created_at', label: 'Creato il' },
      { key: 'downloaded_at', label: 'Scaricato il' }, { key: 'created_by_username', label: 'Creato da' }, { key: 'download', label: 'Scarica' }],
      activity: [],
      activityFields: [
        {
          key: 'causer_username',
          label: 'Utente',
        }, {
          key: 'description',
          label: 'Azione',
        },
        {
          key: 'created_at',
          label: 'Data',
        }],
      loadingShow: false,
    }
  },
  computed: {
    expirationFolder() {
      const row = this.files.find(el => el.id === this.currentObject)
      return row && row.is_folder ? row : null
    },
    hasExpirationDate() {
      return Boolean(this.expirationFolder)
        && expirationHelpers.normalizeDate(this.expirationFolder.expiration_date) !== null
    },
    canEditExpiration() {
      return Boolean(this.expirationFolder) && this.$can('update', 'object') === true
    },
  },
  watch: {
    currentObject: {
      handler() {
        this.id = this.currentObject
        this.detail()
      },
      deep: true,
    },
  },
  methods: {
    async detail() {
      this.loadingShow = true
      if (this.currentObject === 0) {
        return
      }
      this.data = []
      try {
        const file = this.files.find(el => el.id === this.currentObject)
        if (file.version.at(-1)) {
          this.data.push({
            label: 'Nome',
            value: file.version.at(-1).label,
          })
          this.data.push({
            label: 'Ultimo Download',
            value: this.dateHelpers.format(file.version.at(-1).downloaded_at),
          })

          const createDate = this.dateHelpers.format(file.version[0].created_at)

          this.data.push({
            label: 'Data Creazione',
            value: createDate,
          })
          this.data.push({
            label: 'Data Modifica',
            value: this.dateHelpers.format(file.version[0].updated_at),
          })
        }
        
      console.log(file.activity)
        file.activity.forEach(e => {
          if (e.event === 'publish') {
            const name = e.description
            e.description = `condiviso a ${name}`
          }
          e.created_at = this.dateHelpers.format(e.created_at)
        })
        this.activity = file.activity

        file.version.forEach(e => {
          e.created_at = this.dateHelpers.format(e.created_at)
        })
        this.version = file.version
      } catch (error) {
        // TODO
      }
      this.loadingShow = false
    },
    async download(uuid, label) {
      const { data } = await objectsRepository.download(
        uuid,
      )
      window.open(data.data.link, '_blank')
      // const fileLink = document.createElement('a')

      //   fileLink.href = data.data.link
      //   fileLink.setAttribute('target', '_blank')
      //   fileLink.setAttribute('download', this.file.label)
      //   console.log(this.file.label)
      //   document.body.appendChild(fileLink)

      //   fileLink.click()
    },
    editExpiration() {
      if (!this.canEditExpiration) {
        return
      }
      this.$bvModal.show('expiration-modal')
    },
    close() {
      this.$emit('close')
    },
    formatDatetime(time) {
      if (time) {
        return moment(time).format('DD-MM-YYYY HH:mm:ss')
      }
      return '-'
    },
  },
}
</script>

<style>
[dir="ltr"] .modal-header .close {
  margin: -0.5rem -0.6rem -0.5rem auto;
}
</style>
